import { createChatIframe, showIframe, hideIframe } from "@shared/lib/iframe/iframe-manager";
import { WALTER_HOST } from "../env-vars";

let chatIframe: HTMLIFrameElement | null = null;

/**
 * Sets up the chat iframe in the specified container.
 *
 * @param container - The HTML element to append the iframe to
 * @param workspaceId - The workspace ID to load the chat for
 * @param conversationId - Optional conversation ID to load a specific conversation
 * @returns The created iframe element
 */
export function setupChatIframe(
  container: HTMLElement,
  workspaceId: string,
  conversationId?: string,
): HTMLIFrameElement {
  // Build the chat URL - handshake will identify this as Word add-in
  let chatUrl = `${WALTER_HOST}/workspaces/${workspaceId}/ai/chats/`;
  chatUrl += conversationId ? conversationId : "new";

  // Create iframe using shared library
  chatIframe = createChatIframe(container, chatUrl, {
    allow: "clipboard-read; clipboard-write",
    className: "word-chat-iframe",
  });

  return chatIframe;
}

/**
 * Shows the chat iframe
 */
export function showChat(): void {
  if (chatIframe) {
    showIframe(chatIframe);
  }
}

/**
 * Hides the chat iframe
 */
export function hideChat(): void {
  if (chatIframe) {
    hideIframe(chatIframe);
  }
}

/**
 * Gets the current chat iframe instance
 */
export function getChatIframe(): HTMLIFrameElement | null {
  return chatIframe;
}

/**
 * Navigates the chat iframe to a specific conversation
 */
export function navigateToConversation(workspaceId: string, conversationId: string): void {
  if (chatIframe) {
    chatIframe.src = `${WALTER_HOST}/workspaces/${workspaceId}/ai/chats/${conversationId}`;
  }
}

/**
 * Navigates the chat iframe to create a new conversation
 */
export function navigateToNewChat(workspaceId: string): void {
  if (chatIframe) {
    chatIframe.src = `${WALTER_HOST}/workspaces/${workspaceId}/ai/chats/new`;
  }
}
